/* eslint-disable no-unreachable */
// Define TypeScript interfaces for the API response
export interface MedicalCertificate {
  title: string;
  icon: string;
  list: string[];
  details_link: string;
}

const staticCertificatesData: MedicalCertificate[] = [
  {
    title: "(OGUK) Oil & Gas UK Assessment",
    icon: "fa-medkit",
    list: [
      "OGUK-Standard Offshore Medical Certificate.",
      "OGUK–Fitness To Train Medical-FTT Certificate (BOSIET/HUET).",
      "OGUK-Emergency Response Team Duties-ERT Certificate (Includes Chester Step Test).",
    ],
    details_link: "/oguk-certificate",
  },
  {
    title: `Fitness For Work Assessment/Pre-Employment & Annual Checks/Sickness Absence Management`,
    icon: "fa-stethoscope",
    list: [
      "ABS (American Bureau of Shipping) Medical Fitness Certificate.",
      "ADNOC (Pre-employment/Annual) Medical Fitness Certificate",
      "Brunei Darussalam Medical Certificate",
      "CMA-CGM Medical Certificate",
      "EBM Medical Fitness Certificate.",
      "KBR Medical Fitness Certificate.",
      "Medilink Medical Certificate “eni”",
      "MSC Medical Certificate",
      "NPCC Medical Certificate",
      "PGS Medical Fitness Certificate.",
      "Qatar Energy LNG Medical Certificate",
      "Qatar Energy Medical Certificate",
      "Saipem Medical Fitness Certificate.",
      "Schlumberger Medical Fitness Certificate.",
      "Seachef Medical Certificate",
      "Shell Medical Fitness Certificate.",
      "Technip Medical Certificate",
      "Tidewater Medical Fitness Certificate.",
      "TOTAL Medical Certificate",
      "Wood Medical Certificate",
    ],
    details_link: "/fitness-for-work-assessment",
  },
  {
    title:
      "Seafarer Medical Fitness Assessment (In Accordance with STCW Standards & ILO Guidelines)",
    icon: "fa-user-md",
    list: [
      "Medical Certificate for Personnel Service on Board.",
      "Vanuatu Medical Fitness Certificate.",
      "Marshall Islands Medical Fitness Certificate.",
      "Liberia Medical Fitness Certificate.",
    ],
    details_link: "/seafarer-medical-fitness-assessment",
  },
  {
    title: "Shoulder Measurement Certificate",
    icon: "fa-heart",
    list: [],
    details_link: "/shoulder-measurement",
  },
  {
    title: "Rope Access Medical Fitness Certificate (IRATA)",
    icon: "fa-scissors",
    list: [],
    details_link: "/rope-access-or-irata",
  },
  {
    title: "IMCA Diving Certificates",
    icon: "fa-heart",
    list: [
      "Professional Diver’s Logbook Certificate",
      "Diving Supervisor’s Logbook Certificate",
      "Diving Superintendent’s Logbook Certificate",
      "Diving Inspection’s Logbook Certificate",
      "Technician’s Logbook Certificate",
      "Life Support Technician’s Logbook Certificate",
      "Beginner Diving Fitness certificate",
      "Certificat de Plongeur Professionnel",
    ],
    details_link: "/imca-diving-certificates",
  },
];

const apiUrl = "https://dotmedica.com/nodes/getMedicalCertificatesData";

// Fetch function to retrieve medical certificates data from the API
export async function fetchMedicalCertificates(): Promise<
  MedicalCertificate[]
> {
  try {
    return staticCertificatesData;

    const response = await fetch(apiUrl);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: MedicalCertificate[] = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching medical certificates data:", error);
    throw error;
  }
}
